import { SET_SELECTED_INDEX } from "../actions/quizResult";

const initialState = {
  selectedIndex: -1
};

export default function quizReducer(state = initialState, action) {
  switch (action.type) {
    case SET_SELECTED_INDEX:
      const index = action.payload;
      const selectedIndex = state.selectedIndex === index ? -1 : index;
      return { ...state, selectedIndex };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/quizResult.js